import { REDUCER } from '../reducers/reducersConst';

let defaultTaskState = {
  tasks: undefined,
  loadTasks: false,
  currentTasks: { pages: 1, currentPage: 0, tasks: [], fetching: false },
  finishedTasks: { pages: 1, currentPage: 0, tasks: [], fetching: false },
  futureTasks: { pages: 1, currentPage: 0, tasks: [], fetching: false },
  filteredTasks: { pages: 1, currentPage: 0, tasks: [], fetching: false },
  datesRangeFilter: undefined,
  keywordsFilter: undefined,
  selectedTask: undefined,
  studentsAssigned: undefined,
  modalOpenTask: undefined,
  activeTaskTab: undefined,
  contentsNotFound: false
};

export let task = (state = defaultTaskState, action) => {
  switch (action.type) {
    case REDUCER.TASK.SET_TASKS:
      return {
        ...state,
        tasks: action.tasks
      };
    case REDUCER.TASK.SET_ACTIVATE_STATE:
      return {
        ...state,
        loadTasks: !state.loadTasks
      };
    case REDUCER.TASK.SET_CURRENT_TASKS:
      return {
        ...state,
        currentTasks: Object.assign({}, state.currentTasks, { tasks: action.tasks })
      };
    case REDUCER.TASK.SET_CURRENT_TASKS_PAGES:
      return {
        ...state,
        currentTasks: Object.assign({}, state.currentTasks, { pages: action.pages })
      };
    case REDUCER.TASK.SET_CURRENT_TASKS_CURRENT_PAGE:
      return {
        ...state,
        currentTasks: Object.assign({}, state.currentTasks, { currentPage: action.currentPage })
      };
    case REDUCER.TASK.SET_CURRENT_TASKS_FETCHING:
      return {
        ...state,
        currentTasks: Object.assign({}, state.currentTasks, { fetching: action.fetching })
      };
    case REDUCER.TASK.SET_FINISHED_TASKS:
      return {
        ...state,
        finishedTasks: Object.assign({}, state.finishedTasks, { tasks: action.tasks })
      };
    case REDUCER.TASK.SET_FINISHED_TASKS_PAGES:
      return {
        ...state,
        finishedTasks: Object.assign({}, state.finishedTasks, { pages: action.pages })
      };
    case REDUCER.TASK.SET_FINISHED_TASKS_CURRENT_PAGE:
      return {
        ...state,
        finishedTasks: Object.assign({}, state.finishedTasks, { currentPage: action.currentPage })
      };
    case REDUCER.TASK.SET_FINISHED_TASKS_FETCHING:
      return {
        ...state,
        finishedTasks: Object.assign({}, state.finishedTasks, { fetching: action.fetching })
      };
    case REDUCER.TASK.SET_FUTURE_TASKS:
      return {
        ...state,
        futureTasks: Object.assign({}, state.futureTasks, { tasks: action.tasks })
      };
    case REDUCER.TASK.SET_FUTURE_TASKS_PAGES:
      return {
        ...state,
        futureTasks: Object.assign({}, state.futureTasks, { pages: action.pages })
      };
    case REDUCER.TASK.SET_FUTURE_TASKS_CURRENT_PAGE:
      return {
        ...state,
        futureTasks: Object.assign({}, state.futureTasks, { currentPage: action.currentPage })
      };
    case REDUCER.TASK.SET_FUTURE_TASKS_FETCHING:
      return {
        ...state,
        futureTasks: Object.assign({}, state.futureTasks, { fetching: action.fetching })
      };
    case REDUCER.TASK.SET_FILTERED_TASKS:
      return {
        ...state,
        filteredTasks: Object.assign({}, state.filteredTasks, { tasks: action.tasks })
      };
    case REDUCER.TASK.SET_FILTERED_TASKS_PAGES:
      return {
        ...state,
        filteredTasks: Object.assign({}, state.filteredTasks, { pages: action.pages })
      };
    case REDUCER.TASK.SET_FILTERED_TASKS_CURRENT_PAGE:
      return {
        ...state,
        filteredTasks: Object.assign({}, state.filteredTasks, { currentPage: action.currentPage })
      };
    case REDUCER.TASK.SET_FILTERED_TASKS_FETCHING:
      return {
        ...state,
        filteredTasks: Object.assign({}, state.filteredTasks, { fetching: action.fetching })
      };
    case REDUCER.TASK.SET_DATE_RANGE_TASKS_FILTER:
      return {
        ...state,
        datesRangeFilter: action.datesRangeFilter
      };
    case REDUCER.TASK.SET_KEYWORDS_TASKS_FILTER:
      return {
        ...state,
        keywordsFilter: action.keywordsFilter
      };
    case REDUCER.TASK.SET_STUDENTS_ASSIGNED:
      return {
        ...state,
        studentsAssigned: action.studentsAssigned
      };
    case REDUCER.TASK.SET_SELECTED_TASK:
      return {
        ...state,
        selectedTask: action.selectedTask
      };
    case REDUCER.TASK.SET_MODAL_OPEN_TASK:
      return {
        ...state,
        modalOpenTask: action.modalOpenTask
      };
    case REDUCER.TASK.SET_EVALUATED_ASSIGNMENT_COMMENTS:
      return {
        ...state,
        selectedTask: { ...state.selectedTask, comments: action.comments }
      };
    case REDUCER.TASK.SET_TASK_RESPONSE_COMMENTS: {
      const updatedTasks = state.currentTasks.tasks
        .filter(task => task.id !== action.task.id)
        .concat(action.task);
      return {
        ...state,
        currentTasks: { ...state.currentTasks, tasks: updatedTasks }
      };
    }

    case REDUCER.TASK.SET_ACTIVE_TAB:
      return {
        ...state,
        activeTaskTab: action.activeTaskTab
      };
    case REDUCER.TASK.SET_CONTENT_NOT_FOUND:
      return {
        ...state,
        contentsNotFound: action.contentsNotFound
      };
    default:
      return state;
  }
};
